<template>
  <Toast />
  <Dialog
    v-model:visible="activarModal"
    :style="{ width: '450px' }"
    header="FECHA VENCIMIENTO"
    class="p-fluid"
    :modal="true"
    @hide="closeModal"
  >
    <div class="product-info p-3 mb-3 border-round-lg shadow-2">
      <div class="text-xl font-bold text-center mb-2">
        {{ producto_fechas.descripcion }}
      </div>
      <div class="text-md text-center">
        Cantidad Total:
        <span class="font-bold text-lg text-primary">{{
          producto_fechas.pivot.cantidad ?? 0
        }}</span>
      </div>
    </div>
    <DataTable
      ref="dtFechaVence"
      :value="producto_fechas.fechas_vencimiento"
      editMode="cell"
      @cell-edit-complete="onChangeEditandoCelda"
      class="p-datatable-sm shadow-2 border-round-lg"
      responsiveLayout="scroll"
      stripedRows
      showGridlines
    >
      <Column class="text-right" field="cantidad" header="CANTIDAD">
        <template #body="slotProps">
          {{ convertirNumeroGermanicFormat(slotProps.data.cantidad) }}
        </template>
        <template #editor="{ data }">
          <InputNumber
            :inputClass="'text-right'"
            :min="0"
            :minFractionDigits="2"
            locale="de-ED"
            v-model="data.cantidad"
            autofocus
          />
        </template>
      </Column>
      <Column
        class="text-center"
        field="fecha_vence"
        header="FECHA VENCIMIENTO"
      >
        <template #body="slotProps">
          {{ transformarFecha(slotProps.data.fecha_vence) }}
        </template>
        <template #editor="{ data }">
          <!-- <Calendar
            v-model="data.fecha_vence"
            :showIcon="true"
            dateFormat="dd/mm/yy"
          /> -->
          <InputText
            v-model="data.fecha_vence"
            type="date"
            class="text-center"
            format="dd/mm/yy"
          />
        </template>
      </Column>
      <Column class="text-center" field="lote" header="LOTE">
        <template #body="slotProps">
          {{ slotProps.data.lote }}
        </template>
        <template #editor="{ data }">
          <InputText v-model="data.lote" />
        </template>
      </Column>
      <Column headerStyle="width: 4rem" bodyStyle="text-align: center">
        <template #header>
          <Button
            :disabled="!puedeAgregar"
            class="p-button-rounded p-button-success p-button-sm"
            icon="pi pi-plus"
            v-tooltip.top="'Agregar nueva fecha'"
            @click="agregarFechaVence"
          />
        </template>
        <template #body="data">
          <Button
            class="p-button-rounded p-button-danger p-button-sm"
            icon="pi pi-trash"
            v-tooltip.top="'Quitar fecha'"
            @click="eliminarFechaVence(data)"
          />
        </template>
      </Column>
    </DataTable>
    <template #footer>
      <div class="flex justify-content-end">
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-secondary p-button-lg p-button-outlined mr-2"
          @click="closeModal"
        />
        <Button
          label="GUARDAR"
          icon="pi pi-save"
          class="p-button-primary p-button-lg"
          @click="registrarFechaVence"
          :loading="enviado"
        />
      </div>
    </template>
  </Dialog>
</template>
<script>
export default {
  name: "FechaVence",
  emits: ["closeModal"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    producto: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      enviado: false,
      activarModal: this.show,
      producto_fechas: this.producto,
    };
  },
  computed: {
    puedeAgregar() {
      const cantidadAsignada = this.producto_fechas.fechas_vencimiento.reduce(
        (total, item) => total + (item.cantidad || 0),
        0
      );
      return cantidadAsignada < this.producto_fechas.pivot.cantidad;
    },
  },
  methods: {
    eliminarFechaVence(data) {
      this.$confirm.require({
        message: `¿Está seguro de quitar la fecha?`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.producto_fechas.fechas_vencimiento.splice(data.index, 1);
        },
      });
    },
    onChangeEditandoCelda(e) {
      let { data, newValue, field } = e;
      data[field] = newValue;
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    closeModal() {
      this.$emit("closeModal");
    },
    registrarFechaVence() {
      this.enviado = true;
      if (this.verificarCantidad()) {
        this.$toast.add({
          severity: "success",
          summary: "Éxito",
          detail: "Se registraron las fechas de vencimiento.",
          life: 3000,
        });
        this.enviado = false;
        this.closeModal();
      } else {
        this.enviado = false;
      }
    },
    agregarFechaVence() {
      const cantidadAsignada = this.producto_fechas.fechas_vencimiento.reduce(
        (total, item) => total + (item.cantidad || 0),
        0
      );
      const cantidadRestante =
        this.producto_fechas.pivot.cantidad - cantidadAsignada;

      if (cantidadRestante > 0) {
        this.producto_fechas.fechas_vencimiento.push({
          cantidad: cantidadRestante,
          fecha_vence: null,
          lote: null,
        });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Atención",
          detail:
            "La cantidad total ya ha sido asignada. No puedes agregar más fechas.",
          life: 3000,
        });
      }
    },
    verificarCantidad() {
      let cantidad_total = 0;
      const es_valido = this.producto_fechas.fechas_vencimiento.every(
        (item) => {
          if (item.cantidad <= 0) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "La cantidad debe ser mayor a 0 en todas las filas.",
              life: 3000,
            });
            return false;
          }
          cantidad_total += item.cantidad;
          return true;
        }
      );

      if (!es_valido) {
        return false;
      }

      if (cantidad_total !== this.producto_fechas.pivot.cantidad) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            "La suma de las cantidades debe coincidir con la cantidad del producto.",
          life: 3000,
        });
        return false;
      }
      return true;
    },
    transformarFecha(fecha) {
      if (!fecha) return "";
      let fechaArray = fecha.split("-");
      return `${fechaArray[2]}/${fechaArray[1]}/${fechaArray[0]}`;
    },
  },
  watch: {
    show(value) {
      this.activarModal = value;
    },
    producto(value) {
      this.producto_fechas = value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/demo/badges.scss";
::v-deep(.editable-cells-table td.p-cell-editing) {
  padding-top: 0;
  padding-bottom: 0;
}
.product-info {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  padding: 1rem;
}
</style>
